// localStorage key used to hand the /gcc-command-centre-v3 response from the
// GCC Reinvention popup to the /cmdcenter page opened in a new tab.
// Stored shape: { command: string, response: <API payload with .dashboardData> }
export const CMD_CENTER_STORAGE_KEY = 'gcc_cmdcenter_agents';
